import apiClient from '../config/axiosInterceptors';
import { ResponseHandler } from '../config/responseHandler';
import { API_ENDPOINTS } from '../constants/api';

class NotificationService {
  /**
   * Get notification count for the current user
   * @returns {Promise<Object>} Notification count response
   */
  async getNotificationCount() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.NOTIFICATION_COUNT);
      const processedResponse = ResponseHandler.handleSuccess(
        response,
        'Notification count fetched successfully',
      );
      return processedResponse;
    } catch (error) {
      throw ResponseHandler.handleError(error, 'Failed to fetch notification count');
    }
  }
}

export default new NotificationService();
